// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_28-6";
export var headerCell = "_28-2";
export var rowWrapper = "_28-4";
export var stickyAggregationCell = "_28-a";
export var stickyAggregationRow = "_28-7";
export var stickyColumnCell = "_28-9";
export var stickyColumnHeaderCell = "_28-8";
export var table = "_28-1";
export var virtualRowWrapper = "_28-5";
export var virtualTableContainer = "_28-0";
export var white = "_28-3";